<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useListItem } from "@/hooks";

defineProps<{ buttonText?: string }>();
const { item, index } = useListItem();
const emit = defineEmits(["click"]);

function onClick(evt: any) {
  emit("click", evt);
}
</script>
<template>
  <nut-button
    class="mp-list-button"
    v-bind="$attrs"
    @click.stop="onClick({ item, index })"
  >
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #default v-else-if="buttonText">
      {{ buttonText }}
    </template>
    <template #icon v-if="$slots.icon">
      <slot name="icon" />
    </template>
  </nut-button>
</template>
<style lang="scss">
.mp-list-button.nut-button--square {
  &.nut-button--mini {
    border-radius: 6px !important;
  }

  &.nut-button--small {
    border-radius: 8px !important;
  }

  &.nut-button--normal {
    border-radius: 10px !important;
  }

  &.nut-button--large {
    border-radius: 12px !important;
  }
}
</style>
